/**
 * Created by Administrator on 2016/12/26.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
// import filters from '../filters';

Vue.use(Vuex);

const state = {
    id: 1, // 页面跳转（个人中心页的）
    IS_FRESH: true,  // 刷新标志,默认设置为true,从登录页面进入时会设置为false
    loadingShow: false,  // 是否显示载入界面
    loadingTimes: 0,     // 对loading请求进行计数,防止当有多个接口请求时,一个请求成功就会导致loading界面结束
    isNetErr: false
};

export default new Vuex.Store({
    state,
    mutations,
    // getters,
    actions
});




// WEBPACK FOOTER //
// ./src/vuex/store.js